import { Link } from 'react-router-dom'

export default function BookingBanner({
  title = 'Klar til at give slip og genfinde roen?',
  description = 'Du er altid velkommen til at booke en tid direkte i kalenderen eller kontakte mig, hvis du har spørgsmål til et behandlingsforløb.',
}) {
  return (
    <section className="relative overflow-hidden rounded-3xl border border-[#D2DEC7] bg-white/95 p-8 sm:p-12 lg:p-14 text-center shadow-xs">
      <div className="mx-auto max-w-xl space-y-4">
        <span className="text-xs uppercase tracking-widest text-[#556D48] font-medium">
          Tidsbestilling & kontakt
        </span>

        <h2 className="font-serif text-3xl sm:text-4xl font-normal text-[#222E1D]">
          {title}
        </h2>

        <p className="text-sm sm:text-base text-[#4F6047] leading-relaxed">
          {description}
        </p>

        <div className="pt-4 flex flex-wrap items-center justify-center gap-3.5 sm:gap-4">
          <a
            href="https://system.easypractice.net/book/online-booking-16"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 rounded-full bg-[#F5D154] hover:bg-[#EABF35] px-7 py-3.5 text-sm font-semibold text-[#1E2718] shadow-xs transition active:scale-[0.98]"
          >
            <i className="fa-solid fa-calendar-check text-xs text-[#1E2718]/80" aria-hidden="true" />
            <span>Book tid online nu</span>
          </a>

          <Link
            to="/kontakt"
            className="inline-flex items-center gap-2 rounded-full border border-[#5C7A4F] bg-white px-6 py-3.5 text-sm font-medium text-[#5C7A4F] transition hover:bg-[#EEF3E8]"
          >
            <span>Kontakt Trine</span>
            <i className="fa-solid fa-arrow-right text-xs text-[#5C7A4F]" aria-hidden="true" />
          </Link>
        </div>

        <div className="pt-6 flex flex-wrap items-center justify-center gap-5 text-xs text-[#596A52]">
          <span className="flex items-center gap-1.5">
            <i className="fa-solid fa-phone text-[#5C7A4F]" aria-hidden="true" />
            <a href="tel:42510105" className="hover:underline font-medium text-[#2B3824]">42 51 01 05</a>
          </span>
          <span className="text-[#C5D0BC]">·</span>
          <span className="flex items-center gap-1.5">
            <i className="fa-solid fa-location-dot text-[#5C7A4F]" aria-hidden="true" />
            <span>Prins Burisvej 41.A, 7500 Holstebro</span>
          </span>
          <span className="text-[#C5D0BC]">·</span>
          <span>1 time og 20 min. afsat</span>
        </div>
      </div>
    </section>
  )
}
